import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

const hasUnresolvedPlaceholder =
  posthogKey?.startsWith('INTAI_ENV_') || posthogHost?.startsWith('INTAI_ENV_')
const shouldDisable =
  import.meta.env.DEV === true || !posthogKey || hasUnresolvedPlaceholder

if (!shouldDisable) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    // Enable scroll depth tracking for engagement metrics
    disable_scroll_properties: false,
    // Preserve UTM params and referrer as user properties for attribution
    custom_campaign_params: [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'ref',
      'gclid',
      'li_fat_id',
    ],
  })
}
